import inter400 from '@fontsource/inter/files/inter-latin-400-normal.woff2?url'
import inter600 from '@fontsource/inter/files/inter-latin-600-normal.woff2?url'
import inter700 from '@fontsource/inter/files/inter-latin-700-normal.woff2?url'
import inter800 from '@fontsource/inter/files/inter-latin-800-normal.woff2?url'
import playfair700 from '@fontsource/playfair-display/files/playfair-display-latin-700-normal.woff2?url'
import playfair800 from '@fontsource/playfair-display/files/playfair-display-latin-800-normal.woff2?url'
import bebas400 from '@fontsource/bebas-neue/files/bebas-neue-latin-400-normal.woff2?url'
import { FONT_FILES, toBase64, type FontData } from '@orisini/studio-kit/fonts'

/**
 * Byte font untuk preview di browser.
 *
 * Preview memakai dokumen yang SAMA PERSIS dengan render server, termasuk
 * font sebagai data URL — jadi berkasnya diambil sekali dari aset Vite lalu
 * diubah ke base64. Daftar ini harus sama dengan `FONT_FILES`; yang
 * ketinggalan membuat `loadFonts()` gagal, bukan diam-diam memakai font lain.
 */
const URLS: Record<string, string> = {
  '@fontsource/inter/files/inter-latin-400-normal.woff2': inter400,
  '@fontsource/inter/files/inter-latin-600-normal.woff2': inter600,
  '@fontsource/inter/files/inter-latin-700-normal.woff2': inter700,
  '@fontsource/inter/files/inter-latin-800-normal.woff2': inter800,
  '@fontsource/playfair-display/files/playfair-display-latin-700-normal.woff2': playfair700,
  '@fontsource/playfair-display/files/playfair-display-latin-800-normal.woff2': playfair800,
  '@fontsource/bebas-neue/files/bebas-neue-latin-400-normal.woff2': bebas400,
}

let janji: Promise<FontData> | null = null

export function loadFonts(): Promise<FontData> {
  janji ??= Promise.all(
    FONT_FILES.map(async (f) => {
      const url = URLS[f.file]
      if (!url) throw new Error(`Font not bundled: ${f.file}`)
      const res = await fetch(url)
      if (!res.ok) throw new Error(`Couldn't load font ${f.family}`)
      return [f.file, toBase64(await res.arrayBuffer())] as const
    }),
  )
    .then((pairs) => Object.fromEntries(pairs) as FontData)
    .catch((err) => {
      // Jangan simpan kegagalan selamanya — coba lagi di pemanggilan berikutnya.
      janji = null
      throw err
    })
  return janji
}
